export const mimeTypeToImageExtension = {"application/vnd.oasis.opendocument.image":"odi",
"application/vnd.oasis.opendocument.image-template":"oti",
"application/x-apple-diskimage":"dmg",
"application/x-iso9660-image":"iso",
"application/x-t3vm-image":"t3",
"image/aces":"exr",
"image/apng":"apng",
"image/avif":"avif",
"image/bmp":"bmp",
"image/cgm":"cgm",
"image/dicom-rle":"drle",
"image/emf":"emf",
"image/fits":"fits",
"image/g3fax":"g3",
"image/gif":"gif",
"image/heic":"heic",
"image/heic-sequence":"heics",
"image/heif":"heif",
"image/heif-sequence":"heifs",
"image/hej2k":"hej2",
"image/hsj2":"hsj2",
"image/ief":"ief",
"image/jls":"jls",
"image/jp2":"jp2",
"image/jpeg":"jpeg",
"image/jph":"jph",
"image/jphc":"jhc",
"image/jpm":"jpm",
"image/jpx":"jpx",
"image/jxr":"jxr",
"image/jxra":"jxra",
"image/jxrs":"jxrs",
"image/jxs":"jxs",
"image/jxsc":"jxsc",
"image/jxsi":"jxsi",
"image/jxss":"jxss",
"image/ktx":"ktx",
"image/png":"png",
"image/prs.btif":"btif",
"image/prs.pti":"pti",
"image/sgi":"sgi",
"image/svg+xml":"svg",
"image/t38":"t38",
"image/tiff":"tif",
"image/tiff-fx":"tfx",
"image/vnd.adobe.photoshop":"psd",
"image/vnd.airzip.accelerator.azv":"azv",
"image/vnd.dece.graphic":"uvi",
"image/vnd.djvu":"djvu",
"image/vnd.dvb.subtitle":"sub",
"image/vnd.dwg":"dwg",
"image/vnd.dxf":"dxf",
"image/vnd.fastbidsheet":"fbs",
"image/vnd.fpx":"fpx",
"image/vnd.fst":"fst",
"image/vnd.fujixerox.edmics-mmr":"mmr",
"image/vnd.fujixerox.edmics-rlc":"rlc",
"image/vnd.microsoft.icon":"ico",
"image/vnd.ms-dds":"dds",
"image/vnd.ms-modi":"mdi",
"image/vnd.ms-photo":"wdp",
"image/vnd.net-fpx":"npx",
"image/vnd.tencent.tap":"tap",
"image/vnd.valve.source.texture":"vtf",
"image/vnd.wap.wbmp":"wbmp",
"image/vnd.xiff":"xif",
"image/vnd.zbrush.pcx":"pcx",
"image/webp":"webp",
"image/wmf":"wmf",
"image/x-3ds":"3ds",
"image/x-cmu-raster":"ras",
"image/x-cmx":"cmx",
"image/x-freehand":"fh",
"image/x-icon":"ico",
"image/x-jng":"jng",
"image/x-mrsid-image":"sid",
"image/x-ms-bmp":"bmp",
"image/x-pcx":"pcx",
"image/x-pict":"pic",
"image/x-portable-anymap":"pnm",
"image/x-portable-bitmap":"pbm",
"image/x-portable-graymap":"pgm",
"image/x-portable-pixmap":"ppm",
"image/x-rgb":"rgb",
"image/x-tga":"tga",
"image/x-xbitmap":"xbm",
"image/x-xpixmap":"xpm",
"image/x-xwindowdump":"xwd"}